import React, { forwardRef } from 'react'
import { Link } from 'react-router-dom'

const LinkWithRef = forwardRef((props, ref) => {
  return <Link ref={ref} {...props} />
})

export default LinkWithRef
